var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4C10.268 4 4 10.268 4 18C4 25.732 10.268 32 18 32C24.5207 32 30.0048 27.5402 31.5591 21.5015L35.4328 22.4985C33.4347 30.2616 26.39 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C23.6566 0 28.7012 2.60892 32 6.68597V2H36V14H24V10H29.4912C26.96 6.37133 22.7554 4 18 4Z",
    fill: "#4E5969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/Reload.7334792ec09f4672dda270cb385bd0b8.svg";
export { ForwardRef as ReactComponent };